// @ts-ignore
import { useEffect } from "react";

import { useIntl } from "react-intl";

import FeatureGates from "@atlaskit/feature-gate-js-client";
import { ProductKeys } from "@atlassiansox/asc-stargate";

import { CrossFlowTouchpointProvider } from "@/components/cross-flow/touchpoint/context";
import { IntercomProvider } from "@/libraries/intercom/src/provider";
import { checkFeatureFlagGate } from "@/utils/feature-flags/check-feature-flag";
import { featureFlags } from "@/utils/feature-flags/feature-flag-manifest";

import { ChatWidgetProvider } from "../../../../components/chat-widget/src/chat-widget";
import { JiraProductDiscoveryTemplate } from "../../../../templates/software/jira/product-discovery/jira-product-discovery-software-page/src/jira-product-discovery.template";

export const JiraProductDiscoveryPage = () => {
    const intl = useIntl();
    const isBootIntercom: boolean = checkFeatureFlagGate(
        featureFlags.gwp1304AddIntercomToJpdProductTour
    );
    useEffect(() => {
        FeatureGates.getLayer("wac-edge-track-routing-layer").get(
            "track",
            "main"
        );
    }, []);
    const intercomAppId = intl.locale === "ja" ? "p0ww63i2" : "";

    const isSalesWidgetBxpWebPlatform: boolean =
        intercomAppId !== "" &&
        checkFeatureFlagGate(featureFlags.salesWidgetBxpWebPlatform);

    const isSalesWidgetBxpWebPlatformDeveloper: boolean = checkFeatureFlagGate(
        featureFlags.salesWidgetBxpWebPlatformDeveloper
    );
    if (isSalesWidgetBxpWebPlatformDeveloper) {
        return (
            <ChatWidgetProvider>
                <CrossFlowTouchpointProvider
                    screenName="wacJpdProductTourPage"
                    productKeys={[ProductKeys.JIRA_PRODUCT_DISCOVERY]}
                >
                    <JiraProductDiscoveryTemplate />
                </CrossFlowTouchpointProvider>
            </ChatWidgetProvider>
        );
    } else if (isSalesWidgetBxpWebPlatform) {
        return (
            <ChatWidgetProvider>
                <CrossFlowTouchpointProvider
                    screenName="wacJpdProductTourPage"
                    productKeys={[ProductKeys.JIRA_PRODUCT_DISCOVERY]}
                >
                    <JiraProductDiscoveryTemplate />
                </CrossFlowTouchpointProvider>
            </ChatWidgetProvider>
        );
    } else {
        return (
            <IntercomProvider
                appId={intercomAppId}
                triggerBoot={isBootIntercom}
            >
                <CrossFlowTouchpointProvider
                    screenName="wacJpdProductTourPage"
                    productKeys={[ProductKeys.JIRA_PRODUCT_DISCOVERY]}
                >
                    <JiraProductDiscoveryTemplate />
                </CrossFlowTouchpointProvider>
            </IntercomProvider>
        );
    }
};
